export const defaultConfig = {
    shouldIncludeAdminModule: true,
    apiBaseUrl: process.env.API_BASE_URL,
    tokenKey: 'cookie.token',
    campaignId: '67774c0fe3d6c60ba6748316',
    chatbotBaseUrl: 'https://crm.api.marktine.com',
    sessionIdKey: 'sessionStorage.session_id',
    usePayloadKey: 'cookie.userPayload',
    externalThemeKey: 'sessionStorage.theme_data',
    externalThemeMapping: {
        vovIconUrl: 'data.bot_footer_styling.bot_voice_button.voice_button_icon',
        vovBackgroundColor: 'data.bot_footer_styling.bot_voice_button.mic_Icon_backgroundColor',
        vovText: 'data.bot_footer_styling.bot_voice_button.voice_button_text',
        vovHide: 'data.bot_footer_styling.bot_voice_button.voice_button_hide',
        vovHoverIcon: 'data.bot_footer_styling.bot_voice_button.mic_Icon_hover',
        vovHoverColor: 'data.bot_footer_styling.bot_voice_button.mic_Icon_hover_color',
        vovHeight: 'data.bot_footer_styling.bot_voice_button.height',
        vovWidth: 'data.bot_footer_styling.bot_voice_button.witdh',
    },
    icons: {
        vovIcons: 'icon1',
        modalIcons: 'icon1',
    },
    voiceType: 'female',
};
